import TaskDetailPage from './TaskDetailPage';

export default TaskDetailPage;
